"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Input = exports.inputStyles = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("../constants");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _InputLabel = _interopRequireDefault(require("./InputLabel"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["required", "label", "labelStyle", "error", "labelTooltip", "style"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var inputStyles = (0, _styledComponents.css)(["width:100%;padding:14px 10px;margin-bottom:8px;border-radius:3px;border:0;font-size:1rem;box-sizing:border-box;color:#fff;box-shadow:none;", ";"], function (props) {
  if (props.inputStyle === "dark") {
    return (0, _styledComponents.css)(["background-color:#062633;&::-webkit-input-placeholder{color:#12576e;opacity:1 !important;}&:-moz-placeholder{color:#12576e;}&::-moz-placeholder{color:#12576e;}&:-ms-input-placeholder{color:#12576e;}&:disabled{background-color:#031117;}"]);
  } else if (props.inputStyle === "darker") {
    return (0, _styledComponents.css)(["background-color:#061e26;&::-webkit-input-placeholder{color:#12576e;opacity:1 !important;}&:-moz-placeholder{color:#12576e;}&::-moz-placeholder{color:#12576e;}&:-ms-input-placeholder{color:#12576e;}&:disabled{background-color:#000000;}"]);
  } else if (props.inputStyle === "light") {
    return (0, _styledComponents.css)(["color:#000000;background-color:#fff;&::-webkit-input-placeholder{color:#ccc;opacity:1 !important;}&:-moz-placeholder{color:#ccc;}&::-moz-placeholder{color:#ccc;}&:-ms-input-placeholder{color:#ccc;}&:disabled{background-color:#e6e6e6;}"]);
  } else if (props.inputStyle === "muted") {
    return (0, _styledComponents.css)(["background-color:#f7f7f7;border:1px solid #e0e0e0;border-radius:3px;color:#666666;&:disabled{background-color:#e6e6e6;}"]);
  } else if (props.inputStyle === "achievement") {
    return (0, _styledComponents.css)(["font-size:1rem;background-color:#fff;color:#0c0c0c;border:1px solid #e6e6e6;border-radius:3px;padding:18px 14px;&::-webkit-input-placeholder{color:#ccc;opacity:1 !important;}&:-moz-placeholder{color:#ccc;}&::-moz-placeholder{color:#ccc;}&:-ms-input-placeholder{color:#ccc;}&:focus{outline:none;bordercolor:#4a4a4a;}"]);
  } else if (props.inputStyle === "sm_minimal") {
    return (0, _styledComponents.css)(["border-radius:0px;font-size:", "rem;background-color:transparent;color:#000;padding:4px 0;border:0px;border-bottom:1px solid #e6e6e6;&::-webkit-input-placeholder{color:#949494;opacity:1 !important;}&:-moz-placeholder{color:#949494;}&::-moz-placeholder{color:#949494;}&:-ms-input-placeholder{color:#949494;}height:auto;&:focus{outline:none;border-bottom:1px solid #00bbd5;}"], 14 / 16);
  } else if (props.inputStyle === "transparent") {
    return (0, _styledComponents.css)(["color:#000000;background:transparent;"]);
  }
});
exports.inputStyles = inputStyles;

var Input = _styledComponents["default"].input.withConfig({
  displayName: "TextInput__Input"
})(["", ";"], (0, _styledComponents.css)(["", ";"], inputStyles));

exports.Input = Input;

var TextInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var required = _ref.required,
      label = _ref.label,
      labelStyle = _ref.labelStyle,
      error = _ref.error,
      labelTooltip = _ref.labelTooltip,
      style = _ref.style,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
    required: required,
    label: label,
    labelTooltip: labelTooltip,
    labelStyle: labelStyle || rest.inputStyle
  }, /*#__PURE__*/_react["default"].createElement(Input, (0, _extends2["default"])({
    ref: ref,
    required: required,
    type: "text"
  }, rest)));
});

TextInput.propTypes = {
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles),
  labelTooltip: _propTypes["default"].object,
  inputStyle: _propTypes["default"].oneOf(_constants.TextInputTypes),
  onChange: _propTypes["default"].func,
  style: _propTypes["default"].object,
  error: _propTypes["default"].string
};
TextInput.defaultProps = {
  inputStyle: "achievement",
  labelStyle: "gray",
  style: {},
  error: "",
  value: ""
};
var _default = TextInput;
exports["default"] = _default;